import React, {Component} from 'react';
import {connect} from 'react-redux';
import MerchantAction from '../../actions/MerchantAction';
import Preloader from '../Preloader';
import {Control, Form} from 'react-redux-form';
import FileUpload from 'react-fileupload';
import {NotificationManager} from 'react-notifications';
import MerchantConstants from '../../constants/MerchantConstants';
import AuthService from '../../services/AuthService';
import PlacesAutocomplete, {geocodeByAddress} from 'react-places-autocomplete';
import TimePicker from 'rc-time-picker';
import moment from 'moment';
import 'rc-time-picker/assets/index.css';

class MerchantInfoEdit extends Component {
  state = {
    logoChosenText: '',
    backgroundChosenText: '',
    geocodeResults: null,
    loading: false,
    openHours: [
      {
        open_day: 0,
        open_time: '900',
        close_day: 0,
        close_time: '1800',
        closed: false
      },
      {
        open_day: 1,
        open_time: '900',
        close_day: 1,
        close_time: '1800',
        closed: false
      },
      {
        open_day: 2,
        open_time: '900',
        close_day: 2,
        close_time: '1800',
        closed: false
      },
      {
        open_day: 3,
        open_time: 900,
        close_day: 3,
        close_time: 1800,
        closed: false
      },
      {
        open_day: 4,
        open_time: 900,
        close_day: 4,
        close_time: 1800,
        closed: false
      },
      {
        open_day: 5,
        open_time: 900,
        close_day: 5,
        close_time: 1800,
        closed: false
      },
      {
        open_day: 6,
        open_time: 900,
        close_day: 6,
        close_time: 1800,
        closed: false
      }
    ]
  };

  getWeekName(index) {
    let weekNames = [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
      'Sunday'
    ];
    return weekNames[index];
  }

  componentDidMount() {
    this.props.getProfile();
  }

  handleSubmit(data) {
    let opening_hours = this.props.merchant.opening_hours_raw;
    if (opening_hours) {
      this.props.save(data, opening_hours);
    } else {
      this.props.save(data, this.state.openHours);
    }
  }

  handleSelect(address) {
    geocodeByAddress(address).then(results => {
      let result = results[0].address_components;
      let line1 = '';
      let addressResult = {
        line1: '',
        zip: null,
        city: null,
        state: null,
        country: null,
        latitude: results[0].geometry.location.lat(),
        longitude: results[0].geometry.location.lng()
      };
      for (var i = 0; i < result.length; ++i) {
        if (result[i].types[0] == 'street_number') {
          line1 += result[i].long_name;
        }
        if (result[i].types[0] == 'route') {
          line1 += result[i].long_name;
        }
        if (result[i].types[0] == 'postal_code') {
          addressResult.zip = result[i].long_name;
        }
        if (result[i].types[0] == 'postal_code') {
          addressResult.zip = result[i].long_name;
        }
        if (result[i].types[0] == 'administrative_area_level_1') {
          addressResult.state = result[i].long_name;
        }
        if (result[i].types[0] == 'locality') {
          addressResult.city = result[i].long_name;
        }
        if (result[i].types[0] == 'country') {
          addressResult.country = result[i].long_name;
        }
      }
      addressResult.line1 = line1;
      this.props.setAddress(addressResult)
    })
      .catch(error => {
        console.log('Error:', error);
        this.setState({
          geocodeResults: error,
          loading: false,
        })
      })
  }

  handleChange(address) {
    this.props.setAddressField('line1', address);
  }

  onChangeCloseDay(event, index) {
    let opening_hours = this.props.merchant.opening_hours_raw;
    let newOpenHours = opening_hours ? opening_hours : this.state.openHours;
    newOpenHours[index].closed = event.target.checked;
    this.props.setOpenHours(newOpenHours)
  }

  onChange(value, index, position) {
    if (value) {
      let opening_hours = this.props.merchant.opening_hours_raw;
      let newOpenHours = opening_hours ? opening_hours : this.state.openHours;
      let hours = parseInt(value.format('h'));
      let min = value.format('mm').length === 1 ? '0' + value.format('mm') : value.format('mm');
      if (value.format('a') === 'pm') {
        hours += 12;
      };
      if (position === 1) {
        newOpenHours[index].open_day = index;
        newOpenHours[index].open_time = parseInt(hours + min, 10) ;
      } else if (position === 2) {
        let closeDay = value.format('a') === 'am' ? index + 1 : index;
        newOpenHours[index].close_day = closeDay === 7 ? 0 : closeDay;
        newOpenHours[index].close_time = parseInt(hours + '' + min, 10);
      }
      this.props.setOpenHours(newOpenHours)
    }
  }

  template(merchant) {
    var self = this;
    const format = 'h:mm a';
    const openHoursDefault = this.state.openHours;
    let merchantOpenHours = merchant.opening_hours_raw ? merchant.opening_hours_raw : openHoursDefault;
    if (merchantOpenHours.length < 7) {
      let newOpenHours = openHoursDefault;
      merchantOpenHours.forEach((item) => {
        openHoursDefault.forEach((defaultItem, key) => {
          if (defaultItem.open_day === item.open_day)
            newOpenHours[key] = item;
          });
      })
      this.props.setOpenHours(newOpenHours)
    }
    const optionsLogoUpload = {
      baseUrl: MerchantConstants.MERCHANT_URL + AuthService.getUser().id,
      method: 'PUT',
      fileFieldName: 'merchant[logo]',
      requestHeaders: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      accept: 'application/image',
      uploading: function (progress) {
        self.setState({
          isBusyImage: true
        });
        self.setState({
          progressStatus: Math.round(progress.loaded / progress.total * 100)
        });
      },
      chooseFile: function (files) {
        self.setState({logoChosenText: files[0].name})
      },
      uploadSuccess: function (data) {
        self.props.setForm(data.merchant);
        self.setState({
          isBusyImage: false
        });
        NotificationManager.success('Image was successfully uploaded!');
      },
      uploadError: function () {
        NotificationManager.error('Failed to upload file. Only images are supported.')
      },
      uploadFail: function () {
        NotificationManager.error('Failed to upload file. Only images are supported.')
      }
    };
    const optionsBackgroundUpload = {
      baseUrl: MerchantConstants.MERCHANT_URL + AuthService.getUser().id,
      method: 'PUT',
      fileFieldName: 'merchant[background]',
      requestHeaders: {
        'Authorization': 'Token token=' + AuthService.getUser().jwt
      },
      accept: 'application/image',
      uploading: function (progress) {
        self.setState({
          isBusyImage: true
        });
        self.setState({
          progressStatus: Math.round(progress.loaded / progress.total * 100)
        });
      },
      chooseFile: function (files) {
        self.setState({backgroundChosenText: files[0].name})
      },
      uploadSuccess: function (data) {
        self.props.setForm(data.merchant);
        self.setState({
          isBusyImage: false
        });
        NotificationManager.success('Image was successfully uploaded!');
      },
      uploadError: function () {
        NotificationManager.error('Failed to upload file. Only images are supported.')
      },
      uploadFail: function () {
        NotificationManager.error('Failed to upload file. Only images are supported.')
      }
    };
    const inputProps = {
      type: 'text',
      value: this.props.merchant.address.line1,
      onChange: this.handleChange.bind(this),
      placeholder: 'Address1',
      name: 'line1',
      id: 'line1',
    };

    const optionsGooglePlaceAutocomplete = {
      types: ['address']
    };

    return (
      <div>
        <div className="row" style={{margin: '0px 15px'}}>
          <div className="col-md-12">
            <div className="panel panel-default">
              <div className="panel-heading">
                <h3 className="panel-title">Edit merchant details</h3>
              </div>
              <div className="panel-body">
                <Form model="forms.profileForm" onSubmit={(data) => this.handleSubmit(data)}>
                  <div className="form-group">
                    <label htmlFor="name">Name</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.name" id="name"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email</label>
                    <div className="form-control">{merchant.email}</div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Contact email</label>
                    <Control.text type="email" className="form-control" model="forms.profileForm.contact_email"
                                  id="email"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="phone_number">Phone number</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.display_phone"
                                  id="phone_number"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="description">Description</label>
                    <Control.textarea maxLength={255} type="text" className="form-control" model="forms.profileForm.description"
                                      id="description"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="website">Website</label>
                    <Control.textarea type="text" className="form-control" model="forms.profileForm.website"
                                      id="website"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="logo">Logo</label>
                    <div className="image-box logo">
                      <img src={merchant.logo_url} alt=""/>
                      <div style={{margin: '5px 0'}}>
                        {this.state.logoChosenText}
                      </div>
                      <FileUpload options={optionsLogoUpload}>
                        <a ref="chooseBtn"
                           className="btn btn-default">
                          Choose image
                        </a>
                        <a ref="uploadBtn"
                           disabled={this.state.logoChosenText === ''}
                           className="ml10 btn btn-primary">
                          Upload
                        </a>
                      </FileUpload>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="logo">Background</label>
                    <div className="image-box">
                      <img src={merchant.background_url} alt=""/>
                      <div style={{margin: '5px 0'}}>
                        {this.state.backgroundChosenText}
                      </div>
                      <FileUpload options={optionsBackgroundUpload}>
                        <a ref="chooseBtn"
                           className="btn btn-default">
                          Choose image
                        </a>
                        <a ref="uploadBtn"
                           disabled={this.state.backgroundChosenText === ''}
                           className="ml10 btn btn-primary">
                          Upload
                        </a>
                      </FileUpload>
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="line1">Address 1</label>
                    <PlacesAutocomplete
                      options={optionsGooglePlaceAutocomplete}
                      onSelect={this.handleSelect.bind(this)}
                      onEnterKeyDown={this.handleSelect.bind(this)}
                      inputProps={inputProps}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="line2">Address 2</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.address.line2"
                                  id="line2"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="city">City</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.address.city"
                                  id="city"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="website">State</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.address.state"
                                  id="state"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="zip">Zip</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.address.zip" id="zip"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="latitude">Latitude</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.latitude"
                                  id="latitude"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="longitude">Longitude</label>
                    <Control.text type="text" className="form-control" model="forms.profileForm.longitude"
                                  id="longitude"/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="visible_to_customers">Public Profile</label>
                    <Control.checkbox model="forms.profileForm.visible_to_customers" id="visible_to_customers"
                                      style={{margin: '0px 15px'}}/>
                  </div>
                  <div className="form-group">
                    <label htmlFor="referral_bonus">Merchant types</label>
                    <Control.select model="forms.profileForm.types_id" id="types_id" multiple="true"
                                    style={{margin: '0px 15px'}}>
                      {this.props.types.map(option => <option value={option.code}
                                                              key={option.code}>{option.name}</option>)}
                    </Control.select>
                  </div>
                  <div className="form-group">
                    <label htmlFor="opening_hours">Opening hours</label>
                    <div className="opening-hours-block">
                      {merchantOpenHours.sort((a, b) => a.open_day > b.open_day).map((item, key) => {
                        let openTimeHour = item.open_time.toString().length === 3 ? item.open_time.toString().substr(0,1) :  item.open_time.toString().substr(0,2);
                        let closeTimeHour = item.close_time.toString().length === 3 ? item.close_time.toString().substr(0,1) :  item.close_time.toString().substr(0,2);
                        let openTimeMin = parseInt(item.open_time.toString().substr(item.open_time.toString().length - 2, item.open_time.toString().length));
                        let closeTimeMin = parseInt(item.close_time.toString().substr(item.close_time.toString().length - 2, item.close_time.toString().length));
                        return <div key={key} className="opening-hours-box">
                                  <label className="label-opening-hours">{this.getWeekName(item.open_day)}: </label>
                                  <TimePicker
                                    showSecond={false}
                                    disabled={item.closed}
                                    defaultValue={moment().hour(parseInt(openTimeHour)).minute(openTimeMin)}
                                    className="inline"
                                    onChange={(value) => this.onChange(value, key, 1)}
                                    format={format}
                                    use12Hours
                                    inputReadOnly
                                  />
                                  <span className="sep-opening-hours">-</span>
                                  <TimePicker
                                    showSecond={false}
                                    disabled={item.closed}
                                    defaultValue={moment().hour(parseInt(closeTimeHour)).minute(closeTimeMin)}
                                    className="inline"
                                    onChange={(value) => this.onChange(value, key, 2)}
                                    format={format}
                                    use12Hours
                                    inputReadOnly
                                  />
                                  <input type="checkbox" className="ml10 inline" onChange={(e) => this.onChangeCloseDay(e, key)} checked={item.closed}/> <span className="ml10">closed</span>
                                  {!item.closed && item.open_day !== item.close_day ? <span className="ml10"><span className="red">*</span> closes next day</span> : null}
                                </div>
                      })}
                    </div>
                  </div>
                  <div className="panel-control">
                    <button type="submit" className="btn btn-action">Save</button>
                    <a href="/#/merchant_info" className="btn btn-default ml10">
                      Cancel
                    </a>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    const merchant = this.props.merchant;
    const types = this.props.merchant.types;
    if (merchant && !this.props.isBusy && types) {
      return this.template(merchant);
    } else {
      return <Preloader/>
    }

  }
}


export default connect(
  state => ({
    types: state.forms.profileForm.types,
    merchant: state.forms.profileForm,
    isBusy: state.requestStatus,
  }),
  dispatch => ({
    getProfile: () => {
      dispatch(MerchantAction.getMerchantWithTypes());
    },
    save: (dataMerchant, openHours) => {
      dispatch(MerchantAction.edit(dataMerchant, openHours));
    },
    setForm: (data) => {
      dispatch({type: MerchantConstants.SET_PROFILE_FORM, payload: data});
    },
    setOpenHours: (openHours) => {
      dispatch({type: MerchantConstants.SET_OPEN_HOURS, payload: openHours});
    },
    setAddress: (data) => {
      dispatch({type: MerchantConstants.MERCHANT_SET_ADDRESS, payload: data});
    },
    setAddressField: (name, value) => {
      dispatch({type: MerchantConstants.SET_PROFILE_FIELD_ADDRESS, payload: {name, value}});
    }
  })
)(MerchantInfoEdit);



/** WEBPACK FOOTER **
 ** ./src/components/MerchantInfo/edit.js
 **/